/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The Supplier model module.
 * @module model/Supplier
 * @version v1
 */
export class Supplier {
  /**
   * Constructs a new <code>Supplier</code>.
   * @alias module:model/Supplier
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Supplier</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Supplier} obj Optional instance to populate.
   * @return {module:model/Supplier} The populated <code>Supplier</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Supplier();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('lat'))
        obj.lat = ApiClient.convertToType(data['lat'], 'String');
      if (data.hasOwnProperty('lon'))
        obj.lon = ApiClient.convertToType(data['lon'], 'String');
      if (data.hasOwnProperty('api_endpoint'))
        obj.api_endpoint = ApiClient.convertToType(data['api_endpoint'], 'String');
      if (data.hasOwnProperty('distance'))
        obj.distance = ApiClient.convertToType(data['distance'], 'Number');
      if (data.hasOwnProperty('bank_name'))
        obj.bank_name = ApiClient.convertToType(data['bank_name'], 'String');
      if (data.hasOwnProperty('bank_branch'))
        obj.bank_branch = ApiClient.convertToType(data['bank_branch'], 'String');
      if (data.hasOwnProperty('bank_account'))
        obj.bank_account = ApiClient.convertToType(data['bank_account'], 'String');
      if (data.hasOwnProperty('bank_account_name'))
        obj.bank_account_name = ApiClient.convertToType(data['bank_account_name'], 'String');
      if (data.hasOwnProperty('bank_account_type'))
        obj.bank_account_type = ApiClient.convertToType(data['bank_account_type'], 'String');
      if (data.hasOwnProperty('yoco_public_key'))
        obj.yoco_public_key = ApiClient.convertToType(data['yoco_public_key'], 'String');
      if (data.hasOwnProperty('closed_text'))
        obj.closed_text = ApiClient.convertToType(data['closed_text'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Supplier.prototype.id = undefined;

/**
 * @member {String} name
 */
Supplier.prototype.name = undefined;

/**
 * @member {String} image_url
 */
Supplier.prototype.image_url = undefined;

/**
 * @member {String} lat
 */
Supplier.prototype.lat = undefined;

/**
 * @member {String} lon
 */
Supplier.prototype.lon = undefined;

/**
 * @member {String} api_endpoint
 */
Supplier.prototype.api_endpoint = undefined;

/**
 * @member {Number} distance
 */
Supplier.prototype.distance = undefined;

/**
 * @member {String} bank_name
 */
Supplier.prototype.bank_name = undefined;

/**
 * @member {String} bank_branch
 */
Supplier.prototype.bank_branch = undefined;

/**
 * @member {String} bank_account
 */
Supplier.prototype.bank_account = undefined;

/**
 * @member {String} bank_account_name
 */
Supplier.prototype.bank_account_name = undefined;

/**
 * @member {String} bank_account_type
 */
Supplier.prototype.bank_account_type = undefined;

/**
 * @member {String} yoco_public_key
 */
Supplier.prototype.yoco_public_key = undefined;

/**
 * @member {String} closed_text
 */
Supplier.prototype.closed_text = undefined;

